__turbopack_context__.v({
  "icon": "ZerUdW_icon",
  "label": "ZerUdW_label",
  "loading": "ZerUdW_loading",
  "shine": "ZerUdW_shine",
});
